export const FIRESTORE_COLLECTIONS = {
  COMPANIES: "main_companies",
  USERS: "main_users",
  USERS_GROUPS: "main_users_groups",
  USERS_PROFILES: "main_users_profiles",

  HEALTH_PATIENTS_AVALIACAO_TMA: "health_patients_avaliacao_tma",

  TEXT_CONTENTS: "text_contents",
};
